export default "__VITE_ASSET__BpKScJmm__"